import React from 'react';
import BookingConfigurator from '../../components/BookingConfigurator/BookingConfigurator';
import './Booking.css';

const Booking = ({
    vehicle,
    services,
    dbServices,
    pricingRules,
    priceDetails,
    customer,
    user,
    handleVehicleChange,
    handleServiceChange,
    handleCustomerChange,
    setCurrentPage,
    setShowAuthModal,
    setAuthMode,
    handleSubmit,
    quoteError,
    agencySettings
}) => {
    return (
        <div className="booking-page-container">
            <div className="booking-page-header">
                <h2>Prendre Rendez-vous</h2>
                <p>Configurez votre intervention et choisissez votre créneau en quelques clics.</p>
            </div>
            
            <div className="booking-form-wrapper">
                <BookingConfigurator
                    vehicle={vehicle}
                    services={services}
                    dbServices={dbServices}
                    pricingRules={pricingRules}
                    priceDetails={priceDetails}
                    customer={customer}
                    user={user}
                    handleVehicleChange={handleVehicleChange}
                    handleServiceChange={handleServiceChange}
                    handleCustomerChange={handleCustomerChange}
                    setCurrentPage={setCurrentPage}
                    setShowAuthModal={setShowAuthModal}
                    setAuthMode={setAuthMode}
                    onSubmitQuote={handleSubmit}
                    agencySettings={agencySettings}
                />
            </div>


            <section className="booking-page-info">
                <div className="info-item">
                    <span className="info-icon">📍</span>
                    <div>
                        <h4>Zone d'intervention</h4>
                        <p>Toulouse et sa périphérie (rayon de 100km)</p>
                    </div>
                </div>
                <div className="info-item">
                    <span className="info-icon">📞</span>
                    <div>
                        <h4>Besoin d'aide ?</h4>
                        <p>Contactez-nous au 07 58 04 43 77</p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Booking;
